import { h, Fragment } from "preact";
import { useState, useContext } from "preact/hooks";
import { Alert, Box, Button, Chip, DialogActions, DialogContent, Dialog, DialogTitle, Paper, Stack, Typography } from "@mui/material";
import CircularProgress from '@mui/material/CircularProgress';

import HighlightOffIcon from '@mui/icons-material/HighlightOff';

export default function ProcessingUploadDialog(props) {
    console.log("ProcessingUploadDialog", props.state.params);
    //const app = useContext(AppContext);
    const handleClose = () => {
        props.onClose();
    };
    setInterval(myTimer, 2000);
    const [state, setState] = useState({ step: 1, nd: 0, nb: props.state.params.nb });
    function myTimer() {
        fetch("/upload/28cb9cec08704cf987a89c742019fd78/" + props.state.params.uid)
            .then((response) => {
                return response.json();
            })
            .then((res) => {
                switch (res.res) {
                    case "ok":
                        //reset
                        // console.log(res.pld)
                        if (res.pld.s == true) {

                            clearInterval(myTimer);
                            if (props.state.params.failed.length > 0) {
                                setState((state) => ({ ...state, step: 2 }));
                            } else {
                                endOfDialog();
                            }

                        } else {
                            setState((state) => ({ ...state, ...res.pld }));
                        }
                        break;

                    case "err":
                        break;
                    default:
                        break;
                }
            });
    }
    const endOfDialog = () => {
        if (props.state.params.popup_params !== undefined) {
            window.location.href = "/dataroom/" + props.state.params.popup_params.id + "?pnl=" + props.state.params.popup_params.panel + "&cat=" + props.state.params.popup_params.doc.u
        } else {
            window.location.reload();
        }
    }
    return (
        <Dialog onClose={handleClose} aria-labelledby="add-user-dialog" open={props.state.opened} maxWidth="md" fullWidth={false}>
            <DialogTitle id="add-user-dialog">
                <Typography variant="h5">Traitement des documents</Typography>
            </DialogTitle>
            <DialogContent dividers >
                <Stack spacing={1}>
                    {state.step === 1 && <Fragment>
                        <Typography>
                            Veuillez attendre quelques secondes que les éléments soient traités
                        </Typography>
                        <Box sx={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center' }} >
                            <Box p={1}>
                                <CircularProgress />
                            </Box>
                            <Box p={1}>
                                <Typography>
                                    {state.nd}/{state.nb}
                                </Typography>
                            </Box>
                        </Box>
                    </Fragment>}
                    {props.state.params.failed.length > 0 && <Paper>
                        <Alert
                            severity={"error"}
                            //icon={<HighlightOffIcon color="primary" />} 
                            icon={false}
                        >
                            <Typography variant="h5"> Certains éléments n'ont pas été acceptés:</Typography>
                            <Stack spacing={1}>
                                {props.state.params.failed.map((f) => {
                                    return <Box display={"flex"} justifyContent="space-between" alignItems={"center"}>
                                        <Box style="padding-right: 5px;">
                                            <Typography noWrap={true}>{f.name}</Typography>
                                        </Box>
                                        <Box>
                                            <Chip color="error" label={f.reason} size={"small"} />
                                        </Box>
                                    </Box>
                                })}
                            </Stack>
                        </Alert>
                    </Paper>}
                </Stack>

            </DialogContent>
            {
                state.step === 2 && <DialogActions>
                    <Button onClick={endOfDialog} variant="contained">
                        Fermer
                    </Button>
                </DialogActions>
            }
        </Dialog >
    );
}